import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import styles from './LoginPage.module.css';

const API = process.env.REACT_APP_API_URL || 'https://178.105.190.198.nip.io';

export default function LoginPage() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login'); // login | register
  const login = useAuthStore(s => s.login);

  const submit = async () => {
    if (!form.username || !form.password) { setError('Compila tutti i campi'); return; }
    setLoading(true); setError('');
    try {
      let res, data;
      if (mode === 'login') {
        res = await fetch(`${API}/api/v1/auth/token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ username: form.username, password: form.password }),
        });
      } else {
        res = await fetch(`${API}/api/v1/auth/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: form.username, email: `${form.username}@jarvis.local`, password: form.password }),
        });
      }
      data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Errore');
      login(data.access_token, data.username, data.role);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <Zap size={32} />
          <span>JARVIS</span>
        </div>
        <p className={styles.sub}>Personal AI Executive Agent</p>

        <div className={styles.fields}>
          <input
            className={styles.input}
            placeholder="Username"
            value={form.username}
            onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && submit()}
          />
          <input
            className={styles.input}
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && submit()}
          />
        </div>

        {error && <p className={styles.error}>{error}</p>}

        <button className={styles.btn} onClick={submit} disabled={loading}>
          {loading ? 'Accesso…' : mode === 'login' ? 'Accedi' : 'Registra'}
        </button>

        <button className={styles.toggle} onClick={() => setMode(m => m === 'login' ? 'register' : 'login')}>
          {mode === 'login' ? 'Prima volta? Crea account' : 'Hai già un account? Accedi'}
        </button>
      </div>
    </div>
  );
}
